import { IRANIAN_WOMEN_CATEGORIES } from '../constants'
import { IranianWomenItemViewModel } from '../types'

export const filterItemsByCategory = (
    shuffledItems: IranianWomenItemViewModel[] | undefined,
    selectedCategory: string | null
): IranianWomenItemViewModel[] | undefined => {
    const activeFilter = IRANIAN_WOMEN_CATEGORIES.find((cat) => cat.id === selectedCategory)?.name

    return activeFilter ? shuffledItems?.filter((item) => item.category === activeFilter) : shuffledItems
}
